const convertEasingToCSS = (easing) => ({
    '--easing-ease': `cubic-bezier(${easing.Ease.x1}, ${easing.Ease.y1}, ${easing.Ease.x2}, ${easing.Ease.y2})`,
    '--easing-ease-in': `cubic-bezier(${easing.EaseIn.x1}, ${easing.EaseIn.y1}, ${easing.EaseIn.x2}, ${easing.EaseIn.y2})`,
    '--easing-ease-in-out': `cubic-bezier(${easing.EaseInOut.x1}, ${easing.EaseInOut.y1}, ${easing.EaseInOut.x2}, ${easing.EaseInOut.y2})`,
    '--easing-ease-out': `cubic-bezier(${easing.EaseOut.x1}, ${easing.EaseOut.y1}, ${easing.EaseOut.x2}, ${easing.EaseOut.y2})`,
    '--easing-linear': `cubic-bezier(${easing.Linear.x1}, ${easing.Linear.y1}, ${easing.Linear.x2}, ${easing.Linear.y2})`,
    '--easing-practical': `cubic-bezier(${easing.Practical.x1}, ${easing.Practical.y1}, ${easing.Practical.x2}, ${easing.Practical.y2})`,
    '--easing-expressive': `cubic-bezier(${easing.Expressive.x1}, ${easing.Expressive.y1}, ${easing.Expressive.x2}, ${easing.Expressive.y2})`,
    '--easing-bounce': `cubic-bezier(${easing.Bounce.x1}, ${easing.Bounce.y1}, ${easing.Bounce.x2}, ${easing.Bounce.y2})`,
});
const Easing = {
    Ease: 'var(--easing-ease)',
    EaseIn: 'var(--easing-ease-in)',
    EaseInOut: 'var(--easing-ease-in-out)',
    EaseOut: 'var(--easing-ease-out)',
    Linear: 'var(--easing-linear)',
    Practical: 'var(--easing-practical)',
    Expressive: 'var(--easing-expressive)',
    Bounce: 'var(--easing-bounce)',
};

export { Easing, convertEasingToCSS };
